import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        selector: {
            textAlign: 'left',
        },

    }
})

export default useStyles
